import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaSave, FaArrowLeft, FaChevronDown, FaTimes } from "react-icons/fa";
import { IoSchool } from "react-icons/io5";
import { toast } from "react-toastify";
import {
  addTeachersCodes,
  clearState,
} from "../../redux/Slices/TeachersCodesSlice";
import { getAllTeachers } from "../../redux/Slices/TeachersSlice";
import { fetchSettingsGrades } from "../../redux/Slices/GradesSlice";

const AddTeacherCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    teacher_id: "",
    code: "",
    serial: "",
    grade_id: "",
    price: "",
  });

  const [teacherSearch, setTeacherSearch] = useState("");
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  const teacherDropdownRef = useRef(null);

  const { loading, error, success } = useSelector(
    (state) => state.teachers_codes
  );
  const { all_teachers } = useSelector((state) => state.teachers);
  const { settingsGrades } = useSelector((state) => state.grades);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        teacherDropdownRef.current &&
        !teacherDropdownRef.current.contains(e.target)
      ) {
        setShowTeacherDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    dispatch(clearState());
    dispatch(getAllTeachers());
    dispatch(fetchSettingsGrades());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      toast.success("تمت الإضافة بنجاح");
      dispatch(clearState());
      navigate("/teachers_codes");
    }
    if (error) {
      toast.error(error || "لم تتم الإضافة");
      dispatch(clearState());
    }
  }, [success, error, dispatch, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const selectedTeacher = all_teachers?.find(
    (t) => String(t.id) === String(formData.teacher_id)
  );

  const filteredTeachers = all_teachers?.filter((t) =>
    t.name_ar?.toLowerCase().includes(teacherSearch.toLowerCase())
  );

  const handleTeacherSelect = (teacher) => {
    setFormData((prev) => ({ ...prev, teacher_id: String(teacher.id) }));
    setTeacherSearch("");
    setShowTeacherDropdown(false);
  };

  const handleClearTeacher = (e) => {
    e.stopPropagation();
    setFormData((prev) => ({ ...prev, teacher_id: "" }));
    setTeacherSearch("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const containsHTMLOrScript = (val) => {
      if (!val) return false;
      const pattern = /<[^>]*>|javascript:|onerror|onload/i;
      return pattern.test(val);
    };

    if (containsHTMLOrScript(formData.code) || containsHTMLOrScript(formData.serial)) {
      toast.error("غير مسموح بإدخال وسوم برمجية أو أكواد غير آمنة!", { position: "top-center" });
      return;
    }

    // BUG-44 fix: التحقق من أن الكود بصيغة صحيحة (أحرف/أرقام فقط) وغير سالب وغير نص عربي فقط
    const codeValue = String(formData.code || "").trim();
    if (!codeValue) {
      toast.error("كود الحصة مطلوب");
      return;
    }
    if (/^-/.test(codeValue) || (!isNaN(Number(codeValue)) && Number(codeValue) < 0)) {
      toast.error("كود الحصة لا يمكن أن يكون قيمة سالبة");
      return;
    }
    if (!/^[A-Za-z0-9_-]+$/.test(codeValue)) {
      toast.error("كود الحصة يجب أن يتكون من حروف إنجليزية و/أو أرقام فقط (بدون نص عربي أو رموز غير مسموحة)");
      return;
    }

    // BUG-46 fix: التحقق من أن السعر رقم موجب أكبر من صفر
    const priceValue = parseFloat(formData.price);
    if (isNaN(priceValue) || priceValue <= 0) {
      toast.error("السعر يجب أن يكون رقماً أكبر من صفر");
      return;
    }

    dispatch(clearState());
    dispatch(addTeachersCodes(formData));
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div className="container-fluid" style={{ direction: "rtl", padding: "4px 0" }}>
      <style>{`
        .tcode-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .tcode-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
        .tcode-custom-dropdown {
          background-color: #fff !important;
          border: 1.5px solid #e2e8f0 !important;
          border-radius: 9px !important;
          cursor: pointer;
          min-height: 44px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 14px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .tcode-custom-dropdown:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <IoSchool style={{ color: "var(--gray-color)" }} /> إضافة كود جديد
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>توليد كود حصة جديد لمعلم محدد وتعيين السعر والمرحلة</p>
        </div>
        <Link to="/teachers_codes" style={{ textDecoration: "none" }}>
          <button style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 18px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 13 }}>
            <FaArrowLeft size={11} /> العودة
          </button>
        </Link>
      </div>

      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            
            {/* ---- Searchable Teacher Dropdown ---- */}
            <div>
              <label style={labelStyle}>المعلم *</label>
              <div ref={teacherDropdownRef} style={{ position: "relative" }}>
                <div
                  className="tcode-custom-dropdown"
                  onClick={() => setShowTeacherDropdown((p) => !p)}
                >
                  <span style={{ color: selectedTeacher ? "#0f172a" : "#94a3b8", fontSize: 14 }}>
                    {selectedTeacher ? selectedTeacher.name_ar : "اختر معلم"}
                  </span>
                  <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {selectedTeacher && (
                      <FaTimes
                        size={12}
                        style={{ color: "#94a3b8", cursor: "pointer" }}
                        onClick={handleClearTeacher}
                      />
                    )}
                    <FaChevronDown size={11} style={{ color: "#64748b" }} />
                  </span>
                </div>

                <input
                  type="text"
                  name="teacher_id"
                  value={formData.teacher_id}
                  required
                  readOnly
                  style={{ position: "absolute", opacity: 0, height: 0, width: 0, pointerEvents: "none" }}
                  tabIndex={-1}
                />

                {showTeacherDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      zIndex: 1050,
                      background: "#fff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                      marginTop: "4px",
                      padding: "8px"
                    }}
                  >
                    <input
                      autoFocus
                      type="text"
                      className="tcode-input"
                      placeholder="ابحث باسم المعلم..."
                      value={teacherSearch}
                      onChange={(e) => setTeacherSearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      style={{ marginBottom: "8px" }}
                    />
                    <ul
                      style={{
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        maxHeight: "180px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredTeachers?.length > 0 ? (
                        filteredTeachers.map((t) => (
                          <li
                            key={t.id}
                            onClick={() => handleTeacherSelect(t)}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderRadius: "6px",
                              fontSize: 13,
                              background: String(formData.teacher_id) === String(t.id) ? "#ede9fe" : "transparent",
                              fontWeight: String(formData.teacher_id) === String(t.id) ? "700" : "400",
                              color: String(formData.teacher_id) === String(t.id) ? "#4338ca" : "#0f172a",
                            }}
                            onMouseEnter={(e) => {
                              if (String(formData.teacher_id) !== String(t.id)) {
                                e.currentTarget.style.background = "#f1f5f9";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (String(formData.teacher_id) !== String(t.id)) {
                                e.currentTarget.style.background = "transparent";
                              }
                            }}
                          >
                            {t.name_ar}
                          </li>
                        ))
                      ) : (
                        <li style={{ padding: "8px 12px", color: "#94a3b8", fontSize: 13 }}>
                          لا توجد نتائج بحث
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            <div>
              <label style={labelStyle}>الكود *</label>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل كود الحصة..."
                required
              />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>الرقم التسلسلي (Serial) *</label>
              <input
                type="text"
                name="serial"
                value={formData.serial}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="الرقم التسلسلي الفريد..."
                required
              />
            </div>

            <div>
              <label style={labelStyle}>المرحلة الدراسية *</label>
              <select
                className="tcode-custom-select"
                name="grade_id"
                value={formData.grade_id}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>اختر المرحلة الدراسية</option>
                {settingsGrades?.map((grade) => (
                  <option key={grade.id} value={grade.id}>
                    {grade.name_ar}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginBottom: 24, maxWidth: "50%" }}>
            <label style={labelStyle}>السعر *</label>
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              style={inputStyle}
              onFocus={focusHandler}
              onBlur={blurHandler}
              placeholder="السعر بالجنيه..."
              required
              min="0"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button
              type="button"
              onClick={() => navigate("/teachers_codes")}
              style={{ padding: "10px 20px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 14 }}
            >
              إلغاء
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "10px 28px",
                borderRadius: 10,
                border: "none",
                background: loading ? "#c7d2fe" : "linear-gradient(135deg,var(--main-color),var(--main-light))",
                color: "#fff",
                fontWeight: 700,
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 14
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  جاري الحفظ...
                </>
              ) : (
                <>
                  <FaSave size={12} />
                  حفظ الكود
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTeacherCode;
